import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";
import { ReactComponent as ARROW } from "../../assets/ArrowRight.svg";

type OperatingSectionType = {
    attributes: {
        number: number;
        headline: string;
        description: string;
    };
}[];

export default function OperatingSection({ data }: { data: OperatingSectionType }) {
    const [active, setActive] = useState<string>("01");

    const handleSetNumber = (number: string) => {
        active === number ? setActive("") : setActive(number);
    };

    return (
        <div className="flex flex-col w-full max-w-page mb-16">
            {data?.map((item: any, index) => {
                const isActive = active === item.attributes.number.toString();

                return (
                    <div
                        key={item.attributes.number}
                        onClick={() => handleSetNumber(item.attributes.number.toString())}
                        className={`flex flex-col cursor-pointer  gap-4 w-full border-b transition-all duration-300 bg-base-100 active:bg-secondary/10 active:border-secondary active:rounded-xl ${isActive
                                ? "bg-secondary/10 rounded-xl border-secondary"
                                : "border-base-300"
                            } pb-6 pt-7 px-8 sm:px-16 `}>
                        <div
                            
                            className={`relative  flex justify-between items-center`}
                        >
                            <div className="flex flex-row gap-4">
                                <p className="text-xl sm:text-3xl font-semibold font-headline">
                                    {item.attributes.number}
                                </p>
                                <p className="text-xl sm:text-3xl font-semibold font-headline">
                                    {item.attributes.headline}
                                </p>
                            </div>



                            <motion.div
                                initial={{ rotate: 0 }}
                                animate={{ rotate: isActive ? -405 : 0 }}
                                transition={{ duration: 0.3, ease: "easeInOut" }}
                            >
                                <ARROW className="w-8 h-8 text-secondary" />
                            </motion.div>
                        </div>
                        <AnimatePresence initial={false}>
                            {isActive && (
                                <motion.div
                                    key="content"
                                    initial={{
                                        height: 0,
                                        opacity: 0,
                                    }}
                                    animate={{
                                        height: "auto",
                                        opacity: 1
                                    }}
                                    exit={{
                                        height: 0,
                                        opacity: 0
                                    }}
                                    transition={{
                                        duration: 0.3,
                                        type: "easeOut",
                                        bounce: 0
                                    }}
                                    className="overflow-hidden "
                                >
                                    <div className="py-6">
                                        <p className="text-accent/80">
                                            {item.attributes.description}
                                        </p>
                                    </div>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>
                );
            })}
        </div>
    );
}